.picker {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-1);
  align-items: center;
}
